import { mountInviteDock } from '@bn-games/ui-shell';
import { pillBottomInCanvas } from '../scenes/wallCountOrigin.js';
import type { Scene } from './types.js';

export interface SocialDockOptions {
  readonly serverUrl: string;
  /** True while a hand is actively being played; Accept then asks first. */
  readonly isGameInProgress: () => boolean;
}

export interface SocialDock {
  /** Call on every scene change: the main menu gets the full card, every other scene the pill. */
  showScene(scene: Scene): void;
  /** The pill's bottom edge in `canvas`'s drawing space, or null while it isn't showing. */
  pillBottomOn(canvas: HTMLCanvasElement, canvasCssHeight: number): number | null;
  /** Fires whenever the pill appears, disappears or resizes, so the table can repaint. */
  onPillChange(listener: () => void): void;
}

/**
 * Mounts the page-lifetime invite dock once at boot. The app starts on the
 * main menu, so the dock starts `expanded`. The pill's footprint is kept here
 * because mahjong's wall-count readout moves out from under it.
 */
export function mountSocialDock(opts: SocialDockOptions): SocialDock {
  const dock = mountInviteDock({
    serverUrl: opts.serverUrl,
    density: 'expanded',
    isGameInProgress: opts.isGameInProgress,
  });
  let footprint: DOMRectReadOnly | null = null;
  dock.onCompactFootprintChange((rect) => {
    footprint = rect;
  });
  return {
    showScene(scene) {
      dock.setDensity(scene === 'menu' ? 'expanded' : 'compact');
    },
    pillBottomOn(canvas, canvasCssHeight) {
      if (footprint === null) return null;
      return pillBottomInCanvas(footprint, canvas.getBoundingClientRect(), canvasCssHeight);
    },
    onPillChange(listener) {
      dock.onCompactFootprintChange(() => listener());
    },
  };
}
